module.exports = __webpack_public_path__ + "img/pic2-mobile.32a48d97.svg";